import React from 'react'

import { T } from '@transifex/react'
import { DATE_MEDIUM_FULL, formatDateTime } from '@vend/utilities'
import { isNotHiddenPayment } from '../../../functions/sale'
import { useRegisterManager } from '../../../ng-compat/hooks'
import { getFeatureFromCache } from '../../../util/feature-cache'
import { LRX_39407_CHEQUE_REFERENCE_WRITE } from '../../../constants/wr-features'
import { useAppSelector } from '../../../state/hooks'
import { selectSalePayments } from '../../../state/slices/currentSale/currentSaleSlice'
import { useFormatCurrencyValue } from './useFormatCurrencyValue'

export const PaymentSection = () => {
  const payments = useAppSelector(selectSalePayments)
  const currentOutlet = useRegisterManager().getActiveOutlet()
  const formatCurrencyValue = useFormatCurrencyValue()
  const filteredPayments = payments.filter(isNotHiddenPayment)
  if (!filteredPayments.length) {
    return null
  }

  return (
    <section
      className="sale-summary-section sale-summary-section--indent pro-summary-section-payments"
      data-testid="summary-panel-payments"
    >
      <ul className="sale-summary-list">
        {filteredPayments.map(payment => {
          const {
            paymentType: { name: paymentName },
            paymentDate,
            amount,
          } = payment
          return (
            <li
              className="wr-sale-summary-payments sale-summary-line"
              key={payment.localId}
            >
              <div className="sale-summary-line-item sale-summary-line-item--label">
                <span className="pro-sale-summary-payment-name">
                  {paymentName}
                </span>
                {getFeatureFromCache(LRX_39407_CHEQUE_REFERENCE_WRITE) &&
                  payment.paymentReference && (
                    <div className="vd-text-supplementary">
                      <T
                        _str="Reference: {paymentReference}"
                        paymentReference={payment.paymentReference}
                        _context="Payment reference number sub-label"
                      />
                    </div>
                  )}
                <div className="vd-text-supplementary">
                  {formatDateTime(paymentDate, {
                    ...DATE_MEDIUM_FULL,
                    timeZone: currentOutlet.time_zone,
                  })}
                </div>
              </div>
              <div className="sale-summary-line-item sale-summary-line-item--value">
                <span>{formatCurrencyValue(amount)}</span>
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
